import enquire from "enquire.js";

(function () {

    const section = document.getElementById('favorite-section');
    const items = document.querySelectorAll('[data-favorite-item]');
    const categoryVoteButtons = document.querySelectorAll('[data-contestant-id]');
    const favoriteVoteButtons = document.querySelectorAll('[data-favorite-button]');

    let data;
    let contestantData;
    let selectedIds = [null,null,null,null,null,null];
    let isMobile = false;

    function init() {
        categoryVoteButtons.forEach((button) => assignCategoryAction(button));
        favoriteVoteButtons.forEach((button) => assignFavoriteAction(button));

        // Registrovat media query pro mobil
        enquire.register("screen and (max-width: 47.9375em)", {
            match: function() {
                isMobile = true;
                // Pokud je sekce již viditelná, inicializovat slider
                if (section.classList.contains("is-active")) {
                    initFavoriteSlider();
                }
            },
            unmatch: function() {
                isMobile = false;
                // Zničit slider při přechodu na desktop
                const $slider = $('#favorite-section .motorcycles');
                if ($slider.hasClass('slick-initialized')) {
                    $slider.slick('unslick');
                    sliderInitialized = false;
                }
            }
        });

        // TEST BUTTON - odstranit po testování
        window.testFavoriteSlider = function() {
            section.classList.add("is-active");
            initFavoriteSlider();
        };
        console.log('Pro test favorite slideru zavolej v konzoli: testFavoriteSlider()');
    }

    function assignCategoryAction(button) {
        const $button = $(button);

        $button.on('click', function() {
			    setCategoryVote(this.getAttribute('data-contestant-category'),this.getAttribute('data-contestant-id'));
		    });
    }

    function assignFavoriteAction(button) {
        const $button = $(button);

        $button.on('click', function() {
          setFavoriteVote(this);
        });
    }

    function setCategoryVote(contestantCategory,contestantId) {
        items.forEach((item) => refreshItem(item,contestantCategory,contestantId));
    }

    function setFavoriteVote(activeButton) {
        favoriteVoteButtons.forEach((button) => resetButton(button));

        activeButton.classList.add("is-active");
        activeButton.querySelector('label').innerHTML = "Vybráno";
        activeButton.querySelector('input').checked = true;

    }

    function resetButton(button) {
        button.classList.remove("is-active");
        button.querySelector('label').innerHTML = "Zvolit";
    }

    function refreshItem(item,contestantCategory,contestantId) {
        if(contestantCategory === item.getAttribute('data-favorite-item')){
            contestantData = getContestantData(contestantId);

            if(selectedIds[contestantCategory] == contestantId){
              selectedIds[contestantCategory] = null;
            } else {
              selectedIds[contestantCategory] = contestantId;
            }

            item.querySelector('[data-favorite-name]').innerHTML = contestantData[0];
            item.querySelector('[data-favorite-company]').innerHTML = contestantData[1];
            item.querySelector('[data-favorite-logo]').className  = "brand-logo logo-" + contestantData[2];
            const imgBase = contestantData[3].replace('.jpg', '');
            const img = item.querySelector('[data-favorite-image]');
            img.src = "assets/frontend/img/motorcycles2026/" + contestantData[3];
            img.srcset = "assets/frontend/img/motorcycles2026/" + imgBase + "@2x.jpg 2x";
            item.querySelector('input').value = contestantId;

            render();
        }
    }

    let sliderInitialized = false;

    function initFavoriteSlider() {
      if (sliderInitialized || !isMobile) return;
      const $slider = $('#favorite-section .motorcycles');
      // Skrýt před inicializací
      $slider.css('visibility', 'hidden');
      setTimeout(function() {
        $slider.slick({
          centerMode: true,
          arrows: false,
          infinite: false,
          variableWidth: true,
          lazyLoad: 'progressive'
        });
        // Zobrazit po inicializaci
        $slider.css('visibility', 'visible');
        sliderInitialized = true;
        console.log('Favorite slider initialized');
      }, 50);
    }

    function render() {
      const wasActive = section.classList.contains("is-active");
      if(!selectedIds.includes(null)){
        section.classList.add("is-active");
        if (!wasActive) {
          initFavoriteSlider();
        }
      } else {
        section.classList.remove("is-active");
      }
    }

    function getContestantData(contestantId) {
        switch(contestantId) {
            case "1":
                data = ['HONDA SH125i','Honda Motor Europe Ltd., o.s. ČR','hondanew','honda_sh125i.jpg'];
              break;
            case "2":
                data = ['QJMOTOR ATR 125','Mayers Motors s.r.o.','qjmotornew','qjmotor_atr_125.jpg'];
              break;
            case "3":
                data = ['KENTOYA V Cross 125','Kentoya Motors spol.s.r.o','kentoyanew','kentoya_v_cross_125.jpg'];
              break;
            case "4":
                data = ['Zontes 125X','MR43 s.r.o.','zontes','zontes_125x.jpg'];
              break;
            case "5":
                data = ['VOGE 125 RS','Gorex s.r.o.','vogesnew','voge_125_rs.jpg'];
              break;
            case "6":
                data = ['Yuki 125i YMAX','Pyramida Průhonice, s.r.o.','yukinew','yuki_125i_ymax.jpg'];
              break;
            case "7":
                data = ['Yuki 125i XTR II','Pyramida Průhonice, s.r.o.','yukinew','yuki_125i_xtr_ii.jpg'];
              break;
            case "8":
                data = ['Yuki 125i Sport R','Pyramida Průhonice, s.r.o.','yukinew','yuki_125i_sport_r.jpg'];
              break;
            case "9":
                data = ['Aprilia SR GT 400','FABER Gmbh','aprilianew','aprilia_sr_gt_400.jpg'];
              break;
            case "10":
                data = ['VOGE SR3 250i','Gorex s.r.o.','vogesnew','voge_sr3_250i.jpg'];
              break;
            case "11":
                data = ['Zontes 368 Gizmo','MR43 s.r.o.','zontes','zontes_368_gizmo.jpg'];
              break;
            case "12":
                data = ['BMW R 1300 RT','BMW Česká republika','bmwnew','bmw_r_1300_rt.jpg'];
              break;
            case "13":
                data = ['HONDA XL750 Transalp E-Clutch','Honda Motor Europe Ltd., o.s. ČR','hondanew','honda_xl750_transalp.jpg'];
              break;
            case "14":
                data = ['Harley-Davidson Pan America™ 1250 Limited','Harley-Davidson Czech Republic, s.r.o.','harleynew','harley_pan_america_1250.jpg'];
              break;
            case "15":
                data = ['CFMOTO 1000MT-X','JOURNEYMAN CZ s.r.o.','cfmotonew','cfmoto_1000mt_x.jpg'];
              break;
            case "16":
                data = ['Kawasaki KLE500','Kawasaki Motors Europe N.V.','kawasakinew','kawasaki_kle500.jpg'];
              break;
            case "17":
                data = ['Royal Enfield Himalayan 450 Mana Black','Vintage Garage Motors, a.s.','royalenfieldnew','royal_enfield_himalayan_450.jpg'];
              break;
            case "18":
                data = ['Moto Morini X-Cape 1200','MR43 s.r.o.','motomorininew','moto_morini_xcape_1200.jpg'];
              break;
            case "19":
                data = ['BMW R 1300 R','BMW Česká republika','bmwnew','bmw_r_1300_r.jpg'];
              break;
            case "20":
                data = ['HONDA CB1000F','Honda Motor Europe Ltd., o.s. ČR','hondanew','honda_cb1000f.jpg'];
              break;
            case "21":
                data = ['Zontes 703R','MR43 s.r.o.','zontes','zontes_703r.jpg'];
              break;
            case "22":
                data = ['Benda LFC 700 PRO','NEVIMA GROUP s.r.o.','benda','benda_lfc_700_pro.jpg'];
              break;
            case "23":
                data = ['BMW R 1300 RS','BMW Česká republika','bmwnew','bmw_r_1300_rs.jpg'];
              break;
            case "24":
                data = ['HONDA CB1000GT','Honda Motor Europe Ltd., o.s. ČR','hondanew','honda_cb1000gt.jpg'];
              break;
            case "25":
                data = ['Harley-Davidson Street Glide™ Limited','Harley-Davidson Czech Republic, s.r.o.','harleynew','harley_street_glide.jpg'];
              break;
            case "26":
                data = ['QJMOTOR SRK 800','Mayers Motors s.r.o.','qjmotornew','qjmotor_srt_800.jpg'];
              break;
            case "27":
                data = ['SUZUKI GSX-8TT','Suzuki Magyar Corp., branch office Czech Republic','suzukinew','suzuki_gsx_8tt.jpg'];
              break;
            case "28":
                data = ['SUZUKI SV-7GX','Suzuki Magyar Corp., branch office Czech Republic','suzukinew','suzuki_sv_7gx.jpg'];
              break;
            case "29":
                data = ['SUZUKI GSX-R1000R','Suzuki Magyar Corp., branch office Czech Republic','suzukinew','suzuki_gsx_r1000r.jpg'];
              break;
            case "30":
                data = ['HONDA CBR500R E-Clutch','Honda Motor Europe Ltd., o.s. ČR','hondanew','honda_cbr500r.jpg'];
              break;
            case "31":
                data = ['Royal Enfield Goan Classic 350','Vintage Garage Motors, a.s.','royalenfieldnew','royal_enfield_goan_350.jpg'];
              break;
            case "32":
                data = ['KTM 390 Adventure R','KTM CENTRAL EAST EUROPE, s. r. o.','ktmnew','ktm_390_adventure_r.jpg'];
              break;
            case "33":
                data = ['KTM 990 RC R','KTM CENTRAL EAST EUROPE, s. r. o.','ktmnew','ktm_990_rc_r.jpg'];
              break;
            case "34":
                data = ['Yamaha WR125R','Yamaha Motor Europe N.V.','yamahanew','yamaha_wr125r.jpg'];
              break;
            case "35":
                data = ['QJMOTOR SRK 921 RR','Mayers Motors s.r.o.','qjmotornew','qjmotor_srk_921_rr.jpg'];
              break;
            case "36":
                data = ['QJMOTOR SRT 450 RX','Mayers Motors s.r.o.','qjmotornew','qjmotor_srt_450_rx.jpg'];
              break;
            case "37":
                data = ['JAWA 730 Twin','JAWA Moto spol. s r.o.','jawanew','jawa_730_twin.jpg'];
              break;
            case "38":
                data = ['BMW R 12 G/S','BMW Česká republika','bmwnew','bmw_r_12_gs.jpg'];
              break;
            case "39":
                data = ['TRIUMPH TRIDENT 800','Meteor Motor Tech CR, s.r.o.','triumphnew','triumph_trident_800.jpg'];
              break;
            case "40":
                data = ['TRIUMPH SCRAMBLER 900','Meteor Motor Tech CR, s.r.o.','triumphnew','triumph_scrambler_900.jpg'];
              break;
            case "41":
                data = ['TRIUMPH THRUXTON 400','Meteor Motor Tech CR, s.r.o.','triumphnew','triumph_thruxton_400.jpg'];
              break;
          }

        return data;
    }

    init();
})();
